import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "environments/environment";
import { Tool } from "@app/tool/model/tool.model";
import { ToolSet } from "@app/tool/model/toolSet.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";

@Injectable()
export class MaintenancePlansService {
    static readonly API_PLANS_BASE_PATH = `${environment.baseURL}/api/plans`;

    constructor(private http: HttpClient) {
    }

    getPlan(id: number) {
        return this.http.get(`${MaintenancePlansService.API_PLANS_BASE_PATH}/${id}`);
    }

    getPlans(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get(`${MaintenancePlansService.API_PLANS_BASE_PATH}`, {params: params});
    }

    getPlanTools(id: number) {
        return this.http.get(`${MaintenancePlansService.API_PLANS_BASE_PATH}/${id}/tools`);
    }

    getPlanItemsByToolIds(toolIds: number[]) {
        let params = new HttpParams();
        if (toolIds) {
            toolIds.forEach(id => {
                params = params.append('toolIds', id.toString())
            });
        }

        return this.http.get(`${MaintenancePlansService.API_PLANS_BASE_PATH}/items`, {params});
    }

    getMandatoryPlanItemsByToolIds(toolIds: number[]) {
        let params = new HttpParams();
        if (toolIds) {
            toolIds.forEach(id => {
                params = params.append('toolIds', id.toString())
            });
        }

        return this.http.get(`${MaintenancePlansService.API_PLANS_BASE_PATH}/mandatoryItems`, {params});

    }

    createPlan(plan: any) {
        return this.http.post<any>(MaintenancePlansService.API_PLANS_BASE_PATH, this.mapPlan(plan, false));
    }

    deletePlan(id: number) {
        return this.http.delete(`${MaintenancePlansService.API_PLANS_BASE_PATH}/${id}`);
    }

    updatePlan(plan: any, incrementVersion: boolean) {
        return this.http.put<any>(`${MaintenancePlansService.API_PLANS_BASE_PATH}/${plan.id}`, this.mapPlan(plan, incrementVersion));
    }

    mapPlan(plan: any, incrementVersion: boolean) {
        return {
            name: plan.name,
            description: plan.description,
            hasDocuments: plan.hasDocuments,
            version: plan.version,
            incrementVersion: incrementVersion,
            toolIds: this.extractToolIds(plan.tools),
            maintenancePlanItems: this.buildMaintenancePlanItems(plan),
        }
    }

    extractToolIds(tools: (Tool | ToolSet)[]) {
        const ids = [];
        tools.forEach(item => {
            if (item instanceof Tool) {
                ids.push(item.id);
            } else {
                item.tools.forEach(t => ids.push(t.id));
            }
        });
        return ids;
    }

    buildMaintenancePlanItems(plan: any) {
        const result = [];

        if (!plan.activities) {
            if (plan.maintenancePlanItems) {
                plan.maintenancePlanItems.forEach(item => {
                    item.recurrence = null;
                    item.activity = null;
                    item.activityTask = null;
                });
                return plan.maintenancePlanItems;
            }
            return result;
        }

        plan.activities.forEach(a => {
            if (a.recurrences) {
                a.recurrences.forEach(r => {
                    if (r.tasks) {
                        r.tasks.forEach(t => result.push({
                            operationId: a.id,
                            recurrenceId: r.id,
                            operationTaskId: t.id
                        }));
                    }
                });
            }
        });
        return result;
    }
}
